import { render, staticRenderFns } from "./SprintInfos.vue?vue&type=template&id=2537d98c"
import script from "./SprintInfos.vue?vue&type=script&lang=js"
export * from "./SprintInfos.vue?vue&type=script&lang=js"
import style0 from "./SprintInfos.vue?vue&type=style&index=0&id=2537d98c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports